import type { Components, Theme } from '@mui/material/styles';

export const chipTheme: Components<Theme>['MuiChip'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      borderRadius: '8px',
      '& .MuiChip-label': {
        paddingLeft: '10px',
        paddingRight: '10px',
        fontSize: '13px'
      },
      '&.MuiChip-colorError, &.MuiChip-colorSuccess': {
        color: theme.vars.palette.semantic.text.inverse
      }
    }),
    sizeSmall: {
      '& .MuiChip-label': {
        paddingLeft: '8px',
        paddingRight: '8px'
      }
    }
  }
};
